import {giftSvg as Icon__small__giftSvg} from '../Icon__small/Icon__small--gift.js';

export var gift = {
  name: 'gift',
  category: 'icon',
  colorable: true,
  svg: Icon__small__giftSvg,
};
